import React, { useEffect, useState } from "react";
import { RadioButton } from "primereact/radiobutton";
import TenantService from "../service/tenant";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AssetService } from "../service/AssetService";
import { changeUnit, statesList } from "../Actions/index";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { parseResponse } from "../utilities/utillFunction";
import { TowerService } from "../service/TowerService";
import { removeDomainName } from "../utilities/utillFunction";
import { SetUserServiceDataInLocalStorage } from "../utilities/utillFunction";
import { InputText } from "primereact/inputtext";
import { plazaServices } from "./tollPlaza/plazaReportService";
const ServiceList = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [selService, setSelectedService] = useState(null);
    const [selServiceID, setSelectedServiceID] = useState(null);
    const [services, setServices] = useState(null);
    const [showTerms, setShowTerms] = useState(false);
    const [serviceIds, setServiceIds] = useState([]);
    const [filterdPermissionsData, setfilterdPermissionsData] = useState(null);
    const [searchInputValue, setSearchInputValue] = useState('')


    useEffect(() => {
        const getPermission = async () => {
            Promise.all([TenantService.getPermissions(), TenantService.getMenuOptions()]).then((res) => {
                let getPermissionResponse = res[0];
                let isAdmin = false;
                let menu = res[1];
                let menumap = {};
                menu.forEach((m) => {
                    if (!menumap[m.serviceId]) menumap[m.serviceId] = m;
                });
                if (getPermissionResponse && getPermissionResponse.length) {
                    let filterdPermissions = [];
                    let serviceIds = getPermissionResponse.map((p) => {
                        if (p.permissions && p.permissions.length && !isAdmin) {
                            let userPersmissions = p.permissions.find((p) => {
                                return p === "UserManagement.WRITE";
                            });
                            if (userPersmissions) isAdmin = true;
                        }
                        if (p.serviceTypeName) {
                            if (menumap[p.serviceId]) p.menu = menumap[p.serviceId];
                            filterdPermissions.push(p);
                        }
                        return p.serviceId;
                    });
                    if (isAdmin && getPermissionResponse[0].service && !getPermissionResponse[0].service.isTermsAccepted) {
                        setServiceIds(serviceIds);
                        setfilterdPermissionsData(filterdPermissions);
                        setShowTerms(true);
                    } else {
                        if (filterdPermissions.length && filterdPermissions.length === 1) {
                            onServiceSelection(filterdPermissions[0].serviceTypeName, filterdPermissions[0], true);
                        } else {
                            setServices(filterdPermissions);
                        }
                    }
                }
            });
            // let getPermissionResponse = await TenantService.getPermissions();
            // if (getPermissionResponse && getPermissionResponse.length) {
            //     let filterdPermissions = getPermissionResponse.filter((p) => p.serviceTypeName);
            //     if (filterdPermissions.length && filterdPermissions.length === 1) {
            //         onServiceSelection(filterdPermissions[0].serviceTypeName, filterdPermissions[0]);
            //     } else {
            //         setServices(filterdPermissions);
            //     }
            // }
        };
        getPermission();
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'visible';
        };
    }, []);

    const createdynamicsitemenu = (data) => {
        let stateMap = {};
        let cityMap = {};
        let towerCount = 0;
        data.forEach((item) => {
            if (stateMap[item.state]) stateMap[item.state] += item.towers.length;
            else stateMap[item.state] = item.towers.length;
            towerCount += item.towers.length;
        });

        const states = [...new Set(data.map((item) => item.state))];
        let stateitems = [];
        states.forEach((item) => {
            data.forEach((elm) => {
                if (elm.state === item) {
                    if (cityMap[elm.city]) cityMap[elm.city] += elm.towers.length;
                    else cityMap[elm.city] = elm.towers.length;
                }
            });
            let stateitem = {
                label: item,
                icon: "fa-solid fa-location-dot",
                badge: stateMap[item],
                badgeClassName: "p-badge-success color2-bg",
                items: [],
            };
            let cities = data.filter((elm) => elm.state === item);

            cities.forEach((city) => {
                let cityitem = {
                    label: city.city,
                    icon: "fa-solid fa-city",
                    badge: cityMap[city.city],
                    badgeClassName: "p-badge-success color2-bg",
                    items: [],
                };
                let sites = data.filter((elm) => elm.city === city.city && elm.state === item);
                sites.forEach((site) => {
                    site.towers.forEach((tower) => {
                        let siteitem = {
                            label: tower.towerid,
                            icon: "fa-solid fa-tower-cell",
                            to: "/towers-menu/" + tower.siteid + "/" + tower.lat + "/" + tower.lng,
                        };
                        cityitem.items.push(siteitem);
                    });
                });
                stateitem.items.push(cityitem);
            });
            stateitems.push(stateitem);
        });
        let dynamicmenu = {
            label: "Digitized Sites - " + towerCount,
            icon: "pi pi-fw pi-home",
            items: stateitems,
        };
        return dynamicmenu;
    };
    const createdynamicsitemenuinprogress = (data) => {
        let stateMap = {};
        let cityMap = {};
        let towerCount = 0;
        data.forEach((item) => {
            if (stateMap[item.state]) stateMap[item.state] += item.towers.length;
            else stateMap[item.state] = item.towers.length;
            towerCount += item.towers.length;
        });
        const states = [...new Set(data.map((item) => item.state))];
        let stateitems = [];
        states.forEach((item) => {
            data.forEach((elm) => {
                if (elm.state === item) {
                    if (cityMap[elm.city]) cityMap[elm.city] += elm.towers.length;
                    else cityMap[elm.city] = elm.towers.length;
                }
            });
            let stateitem = {
                label: item,
                icon: "fa-solid fa-location-dot",
                badge: stateMap[item],
                badgeClassName: "p-badge-success color2-bg",
                items: [],
            };
            let cities = data.filter((elm) => elm.state === item);
            cities.forEach((city) => {
                let cityitem = {
                    label: city.city,
                    icon: "fa-solid fa-city",
                    badge: cityMap[city.city],
                    badgeClassName: "p-badge-success color2-bg",
                    items: [],
                };
                let sites = data.filter((elm) => elm.city === city.city && elm.state === item);
                sites.forEach((site) => {
                    site.towers.forEach((tower) => {
                        let siteitem = {
                            label: tower.towerid,
                            icon: "fa-solid fa-tower-cell",
                            to: "/towers-progress-menu/" + tower.siteid + "/" + tower.region + "/" + tower.invcode,
                        };
                        cityitem.items.push(siteitem);
                    });
                });
                stateitem.items.push(cityitem);
            });
            stateitems.push(stateitem);
        });
        let dynamicmenu = {
            label: "InProgress Sites - " + towerCount,
            icon: "pi pi-fw pi-home",
            items: stateitems,
        };
        return dynamicmenu;
    };
    const onServiceSelection = async (serviceTypeName, service, singleService) => {
        let selMenu = service.menu;
        let mainMenu = [];
        if (selMenu) {
            if (Array.isArray(selMenu.menu)) {
                for (let i = 0; i < selMenu.menu.length; i++) {
                    if (selMenu.menu[i].items) {
                        selMenu.menu[i].items = selMenu.menu[i].items.filter((m) => {
                            if (m.icon) m.iconurl = process.env.REACT_APP_IMAGE_STATIC_URL + "/" + m.icon;
                            else m.icon = "pi pi-fw pi-circle";
                            if (m.url) {
                                m.to = removeDomainName(m.url);
                            }
                            delete m.url;
                            return m.hasOwnProperty("to");
                        });
                        mainMenu.push(selMenu.menu[i]);
                    }
                }

            }
            else if (selMenu.menu && selMenu.menu.items) {
                selMenu.menu.items = selMenu.menu.items.filter((m) => {
                    if (m.icon) m.iconurl = process.env.REACT_APP_IMAGE_STATIC_URL + "/" + m.icon;
                    else m.icon = "pi pi-fw pi-circle";
                    if (m.url) {
                        m.to = removeDomainName(m.url);
                    }
                    delete m.url;
                    return m.hasOwnProperty("to");
                });
                mainMenu.push(selMenu.menu);
            }
            if (serviceTypeName === "Asset Monitoring") {
                let assetService = new AssetService();
                let newAssets = await assetService.getAssets(service.serviceId, {});
                let assets = newAssets.filter((item) => item.hasOwnProperty("location"));
                const states = [...new Set(assets.map((item) => item.location.state))];
                let stateitems = [];
                states.forEach((st) => {
                    let stateitem = {
                        label: st,
                        icon: "fa-solid fa-location-dot",
                        items: [],
                    };
                    let cities = assets.filter((elm) => elm.location.state === st);
                    let town = [...new Set(cities.map((item) => item.location.city))];
                    town.forEach((ci) => {
                        let cityitem = {
                            label: ci,
                            icon: "fa-solid fa-city",
                            items: [],
                        };
                        let sites = assets.filter((elm) => elm.location.city.toLowerCase() === ci.toLowerCase() && elm.location.state === st);
                        sites.forEach((s) => {
                            let siteitem = {
                                label: s.thingName,
                                icon: "pi pi-fw pi-angle-right",
                                to: "/site-details/" + s.thingName,
                            };
                            cityitem.items.push(siteitem);
                        });
                        stateitem.items.push(cityitem);
                    });
                    stateitems.push(stateitem);
                });
                let dynamicmenu = {
                    label: "ASSET LOCATIONS",
                    icon: "pi pi-fw pi-home",
                    items: stateitems,
                };

                mainMenu.push(dynamicmenu);
            }

            await SetUserServiceDataInLocalStorage(service, dispatch);
            localStorage.setItem("menu", JSON.stringify(mainMenu));

            setSelectedService(serviceTypeName);
            setSelectedServiceID(service.serviceId);
            if (singleService) {
                handleOK(singleService, serviceTypeName);
            }
            // if (mainMenu[0].url) {
            //     history.push(removeDomainName(mainMenu[0].url));
            // } else if (serviceTypeName === "TeamTrac") {
            //     history.push("/employee-summery?");
            // }else history.push("/");
        }
    };

    const handleOK = async (singleService, serviceTypeName) => {
        if ((singleService && serviceTypeName === "Towers") || selService === "Towers") {
            const towerService = new TowerService();
            let data = await towerService.getStateWiseMenu();
            let progressData = await towerService.getStateWiseInProgressMenu();
            const dynamicsmenu = createdynamicsitemenu(data);
            const progressDynamicsMenu = createdynamicsitemenuinprogress(progressData);
            if (data.length || progressData.length) {
                let getMenu = JSON.parse(localStorage.getItem("menu"));
                if (progressData.length) {
                    localStorage.setItem("menu", JSON.stringify([...getMenu, dynamicsmenu, progressDynamicsMenu]));
                }
                localStorage.setItem("menu", JSON.stringify([...getMenu, dynamicsmenu]));
            }
        }

        let menu = JSON.parse(localStorage.getItem("menu"));
        if (menu[0]?.url) {
            history.push(removeDomainName(menu[0].url));
        } else if ((singleService && serviceTypeName === "TeamTrac") || selService === "TeamTrac") {
            history.push("/employee-summery?");
        } else history.push("/");
    };

    const confirmationDialogFooter = (
        <>
            <Button type="button" label="Cancel" icon="pi pi-times" onClick={() => logout()} className="p-button-text" />
            <Button type="button" label="Accept" icon="pi pi-check" onClick={() => updateServiceIdForTerms()} className="p-button-text" autoFocus />
        </>
    );
    const termsAndConditionAlert = () => {
        return (
            <Dialog header="Terms and Conditions of Usage" closable={false} visible={showTerms} style={{ width: "350px" }} modal footer={confirmationDialogFooter}>
                <div className="flex align-items-center" style={{ fontSize: "1.2rem" }}>
                    <span>
                        I accept{" "}
                        <a target="_blank" href="/Nextqore-Terms+of+Use&PrivacyPolicy.pdf">
                            Terms and Conditions of Usage
                        </a>
                        .
                    </span>
                </div>
            </Dialog>
        );
    };

    const updateServiceIdForTerms = async () => {
        let email = localStorage.getItem("email");
        let [serviceError, serviceDetails] = await parseResponse(TenantService.allowTAndCForServices({ serviceIds: serviceIds, email }));
        setShowTerms(false);
        if (serviceError) return;

        if (filterdPermissionsData.length && filterdPermissionsData.length === 1) {
            onServiceSelection(filterdPermissionsData[0].serviceTypeName, filterdPermissionsData[0], true);
        } else {
            setServices(filterdPermissionsData);
        }
    };

    const logout = () => {
        setShowTerms(false);
        localStorage.clear();
        history.push("/login");
    };
    const searchInputHandler = (e) => {
        const value = e.target.value;
        setSearchInputValue(value);
    };

   return <div className="bg-gray-100">
        <div className="header_service_list flex flex-column sm:flex-row sm:justify-content-between align-items-center px-5 sm:px-7 my-3">
            <div className="chartHeading grid p-0 m-0 align-items-center  " style={{ color: "#0C6291" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
                    <path d="M11.8281 0V2.92883L18.6682 7.07568V16.9259L11.8281 21.0712V24L21.0883 18.4016V5.60002L11.8281 0Z" fill="#8CC63F" />
                    <path d="M16.4951 15.6021V8.39734L10.5437 4.79469L4.59283 8.39734V15.6021L10.5437 19.2032L16.4951 15.6021Z" fill="#C8C8C8" />
                    <path d="M9.26019 21.0712L2.42007 16.9259V7.07568L9.26019 2.92883V0L0 5.59841V18.4L9.26019 23.9995V21.0712Z" fill="#0C6291" />
                </svg>
                <p className="lg:ml-2">Select Service</p>
            </div>
            <span className="p-input-icon-left w-full sm:w-26rem mt-4 sm:mt-0" >
                <i className="pi pi-search" />
                <InputText value={searchInputValue} onChange={searchInputHandler} type="text" className="w-full  p-inputtext-sm border-round-lg" placeholder="Search Service" style={{ borderRadius: '20px' }} />
            </span>
        </div>

        <div className="sm:px-8 my:2 sm:my-5">
            {termsAndConditionAlert()}
            {services && services.length !== 0 ? (
                (() => {
                    // const filteredServices = services.filter(service =>
                    //     service.serviceTypeName.toLowerCase().includes(searchInputValue.toLowerCase())
                    // );
                     const filteredServices = services.filter((service) =>
                       service?.serviceTypeName?.toLowerCase().includes(searchInputValue.toLowerCase()) ||
                       service?.service?.descriptor?.toLowerCase().includes(searchInputValue.toLowerCase())
                   );

                    return filteredServices.length > 0 ? (
                        <>
                            <div className="grid overflow-auto custom-grid-gap justify-content-center sm:justify-content-start" style={{ maxHeight: '75vh' }}>
                                {filteredServices.map((s, i) => (
                                    <div
                                        key={s.serviceId}
                                        checked={selServiceID === s.serviceId}
                                        value={s.serviceTypeName}
                                        onClick={() => onServiceSelection(s.serviceTypeName, s)}
                                        className="col-11 sm:col-5 bg-white m-2  hover:border-1 service_card_style"
                                    >
                                        <input
                                            type="radio"
                                            id={`service-${i}`}
                                            name="option"
                                            value={s.serviceTypeName}
                                            checked={selServiceID === s.serviceId}
                                            onChange={() => onServiceSelection(s.serviceTypeName, s)}
                                            className="radio-button-service"
                                        />
                                        <label
                                            htmlFor={`service-${i}`}
                                            className="serviceName"
                                            style={{
                                                color: selServiceID === s.serviceId ? '#2A9D8F' : '#1D2129',
                                            }}
                                        >
                                            {s.serviceTypeName}
                                        </label>
                                        <p
                                            className="customerName"
                                            style={{
                                                color: selServiceID === s.serviceId ? '#2A9D8F' : '#1D2129'
                                            }}
                                        >
                                            {s?.service?.descriptor}
                                        </p>
                                    </div>
                                ))}
                            </div>
                            <div className="grid justify-content-center">
                                <Button
                                    label="Continue"
                                    className="reliace-button mb-2 col-10 sm:col-5 my-5"
                                    onClick={handleOK}
                                    style={{ position: 'sticky', fontSize: '0.9rem' }}
                                />
                            </div>
                        </>
                    ) : (
                        <div className="grid overflow-auto custom-grid-gap justify-content-center" style={{ maxHeight: '75vh' }}>
                            <div className="col-10 sm:col-5 bg-white m-2 shadow-4 border-round flex flex-column align-items-center justify-content-center" style={{ minHeight: '150px' }}>
                                <i className="pi pi-exclamation-triangle text-4xl" style={{ color: '#f97316' }}></i>
                                <h3 className="text-xl font-semibold text-center mb-2">No Service Found!</h3>
                                <p className="text-sm text-color-secondary text-center">Please try a different search term.</p>
                            </div>

                        </div>
                    );
                })()
            ) : (
                <div className="grid overflow-auto custom-grid-gap justify-content-center" style={{ maxHeight: '75vh' }}>

                    <div className="col-10 sm:col-5 bg-white m-2 p-4 shadow-4 border-round flex flex-column align-items-center justify-content-center" style={{ minHeight: '150px' }}>
                        <i className="pi pi-spin pi-spinner text-4xl mb-3" style={{ color: '#0ea5e9' }}></i>
                        <h3 className="text-xl font-semibold text-center mb-2">Loading...</h3>
                    </div>
                </div>
            )}

        </div>
    </div>
};

export default ServiceList;

